import { SecondarySideMenuI } from '../../../../../shared/interfaces/secondary-side-menu.interface';

export const COURSE_SECTION_SIDE_MENU_ITEMS: SecondarySideMenuI[] = [
  {
    translationPath: 'common.reports',
    activeIcon: 'svgs/side-menu/active-institutional-goals.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-institutional-goals.svg',
    route: () => 'reports',
    alt: 'reports',
  },
  {
    translationPath: 'sideMenu.correctiveActions',
    activeIcon: 'svgs/side-menu/active-evaluation-criterion.svg',
    nonActiveIcon: 'svgs/side-menu/non-active-evaluation-criterion.svg',
    route: () => 'corrective-actions',
    alt: 'Corrective Actions',
  },
];
